import React from "react";
import { Chip as MuiChip, ChipProps as E100ChipProps } from "e100-react-components";
import { useStyles } from "./styles";

interface ChipProps extends E100ChipProps {}

export const Chip = (props: ChipProps) => {
  const classes = useStyles();
  return (
    <MuiChip
      classes={{
        root: classes.badge,
      }}
      size="small"
      {...props}
    />
  );
};
